import { BarChart3 } from "lucide-react";

const STEP_NAMES = ["Roadmap", "30-day re-check", "Final check-in"];

function Rate({ label, value, count, tone }) {
  return (
    <div>
      <p className="text-[10px] font-mono-d tracking-[0.15em] uppercase text-zinc-500 mb-1">{label}</p>
      <p className={`font-display text-xl ${tone}`}>
        {value}%<span className="text-xs text-zinc-600 ml-1.5 font-mono-d">{count}</span>
      </p>
    </div>
  );
}

export default function WinbackStats({ stats }) {
  if (!stats) return null;
  return (
    <div className="mb-10" data-testid="winback-stats">
      <div className="flex flex-wrap items-center justify-between gap-3 mb-4">
        <div className="flex items-center gap-2.5">
          <BarChart3 className="w-4 h-4 text-amber-400" />
          <h3 className="font-display text-base font-medium tracking-tight text-zinc-100">Win-back performance</h3>
        </div>
        <p className="text-xs font-mono-d text-zinc-500" data-testid="winback-stats-totals">
          {stats.total} waitlisted · <span className="text-emerald-400">{stats.converted} re-qualified</span> · {stats.unsubscribed} opted out
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
        {stats.steps.map((s) => (
          <div key={s.step} className="border border-white/10 rounded-sm p-4 bg-white/[0.02]" data-testid={`winback-step-${s.step}`}>
            <div className="flex items-center justify-between mb-4">
              <p className="text-xs font-mono-d tracking-[0.15em] uppercase text-amber-400">
                Email {s.step} · Day {s.day}
              </p>
              <p className="text-xs text-zinc-500">{STEP_NAMES[s.step - 1]}</p>
            </div>
            <div className="grid grid-cols-4 gap-2">
              <div>
                <p className="text-[10px] font-mono-d tracking-[0.15em] uppercase text-zinc-500 mb-1">Sent</p>
                <p className="font-display text-xl text-zinc-200" data-testid={`winback-sent-${s.step}`}>{s.sent}</p>
              </div>
              <Rate label="Opened" value={s.open_rate} count={s.opened} tone="text-zinc-200" />
              <Rate label="Clicked" value={s.click_rate} count={s.clicked} tone="text-amber-400" />
              <Rate label="Re-qualified" value={s.conversion_rate} count={s.converted} tone="text-emerald-400" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
